const urlParams = new URLSearchParams(window.location.search);
const acaParam = urlParams.get("aca");
const sessionKey = "aca_session";
const oneDay = 24 * 60 * 60 * 1000;
const now = Date.now();
const sessionDataRaw = localStorage.getItem(sessionKey);
const sessionData = sessionDataRaw ? JSON.parse(sessionDataRaw) : null;
let isValidSession = false;
if (sessionData && (now - sessionData.timestamp <= oneDay)) {
  isValidSession = true;
}
if (acaParam && !isValidSession) {
  localStorage.setItem(sessionKey, JSON.stringify({
    aca: acaParam,
    timestamp: now
  }));
  isValidSession = true;
}

document.addEventListener('DOMContentLoaded',()=>{
  let lastClickedLearnMore = null;

  if (isValidSession && document.querySelectorAll('[js-welcome-offer-bar]').length > 0 ) {document?.querySelector('[js-welcome-offer-bar]')?.classList?.remove('hidden')}

  if( document.location.href.includes('scroll=') ){
      let currentDestination = document.location.href;
      let scrollDestination = currentDestination.split('scroll=')[1];
      if( document.querySelectorAll(`[data-anchor="${scrollDestination}"]`).length > 0 ){
        var targetElement = document.querySelector(`[data-anchor="${scrollDestination}"]`);
        var sectionHeaderHeight = document?.querySelector('.section-header')?.clientHeight || 0;
        var byobSectionHeight = document?.querySelector('.byob_ctaAnchorsContainer')?.clientHeight || 0;
        var anchorSectionHeight = document?.querySelector('.anchor-links__sticky')?.clientHeight || 0;
        window.scrollTo({
          top: targetElement.offsetTop - sectionHeaderHeight - byobSectionHeight - anchorSectionHeight,
          behavior: 'smooth'
        }); 
      }
  }else if( document.location.href.includes('#') ){ 
      let currentDestination = document.location.href;
      let scrollDestination = currentDestination.split('#')[1];
      if( document.querySelectorAll(`[data-anchor="${scrollDestination}"]`).length > 0 ){
        var targetElement = document.querySelector(`[data-anchor="${scrollDestination}"]`);
        var sectionHeaderHeight = document?.querySelector('.section-header')?.clientHeight || 0;
        var byobSectionHeight = document?.querySelector('.byob_ctaAnchorsContainer')?.clientHeight || 0;
        var anchorSectionHeight = document?.querySelector('.anchor-links__sticky')?.clientHeight || 0;
        window.scrollTo({
          top: targetElement.offsetTop - sectionHeaderHeight - byobSectionHeight - anchorSectionHeight,
          behavior: 'smooth'
        }); 
      }
  }  
  
  const collapsibleTab = (target)=>{
    target.target.closest('[js-collapsible-outer]').classList.toggle('active');
    if ( target.target.closest('[js-collapsible-outer]').classList.contains('active') ){
      let HeightElementData = target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]');
      target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = `${HeightElementData.scrollHeight}px`;
    }else{
       target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = null;
    }              
  }

  const collapsibleTabOpenTime = (target)=>{
    target.target.closest('[js-collapsible-outer]').classList.toggle('active');
    if ( target.target.closest('[js-collapsible-outer]').classList.contains('active') ){
      target.target.closest(`[js-collapsible-parent]`).querySelectorAll(`[js-collapsible-outer]`).forEach((elm)=>{ if(target.target.closest('[js-collapsible-outer]') != elm ){elm.classList.remove('active'); elm.querySelector('[js-collapsible-content]').style.maxHeight = null;}})
      let HeightElementData = target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]');
      target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = `${HeightElementData.scrollHeight}px`;
    }else{
       target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = null;
    }        
  }

  const overlayRemoved = ()=>{
    document.querySelector('.page-blury-overlay').classList.remove('is-visible','is-visible-mobile');
    document.querySelector('.page-overlay').classList.remove('is-visible');
    document.querySelector('.cart_drawer_main_wrapper').classList.remove('active');
    document.body.classList.remove('overflow-hidden','scrollOff-quickadd','mobile__header_visible','desktop__header_visible','mobile_drawerVisible');
    if( window.screen.width < 750 ){document.body.style.position = '';document.body.style.top = '';document.body.style.width = '';}    
    document.querySelector('.main__header__wrapper').classList.remove('active-dropdown');
    document.querySelectorAll(`.header__megamenu__wrapper`).forEach((elm)=>{ elm.classList.remove('active'); });
    document.querySelector(`[data-mega-menu-mobile-opener="mobile-mega-menu"]`).classList.remove('active');
    document.querySelector(`.section-header`).classList.remove('active');
    document.querySelector(`.js-dropdown-close`).classList.remove('active');
    document.querySelector('[js-lightbox-custom-drawer]').closest('.custom__drawer__management').classList.remove('active');
    document.querySelector('[js-sub-lightbox-custom-drawer]').closest('.custom__drawer__management').classList.remove('active');
    if( document.querySelector('.doctor_dietitian_lightbox') ){ document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``; document.querySelector('.doctor_dietitian_lightbox').classList.remove('active'); }
    document.querySelector('[js-lightbox-custom-drawer]').innerHTML = ``;
    document.querySelector('[js-sub-lightbox-custom-drawer]').innerHTML = ``;
    document.querySelector('[js-quick-add-layout-setup]').innerHTML = ``;
    if( document.querySelectorAll('.ci__support__shop_confirmation').length > 0 ){
      document.querySelector('.ci__support__shop_confirmation').classList.remove('active');
    }
    if( document.querySelectorAll('.healthcare_practitioners__mainwrapper').length > 0 ){
      document.querySelector('.healthcare_practitioners__mainwrapper').classList.remove('active');
    }
    if( document.querySelectorAll('.open__drawerLink').length > 0 ){
      document.querySelectorAll('.open__drawerLink').forEach((el)=>{el.classList.remove('active') });
    }
    if( document?.querySelector(`[js-cm-main-outer-stepper]`)?.querySelectorAll(`.for__step__one`)?.length > 0 ){
        document?.querySelector(`[js-cm-main-outer-stepper]`)?.querySelector(`.for__step__second`)?.classList?.remove('active');
        document?.querySelector(`[js-cm-main-outer-stepper]`)?.querySelector(`.for__step__one`)?.classList?.remove('hidden');
        document?.querySelector(`.twv__split___renders__drawer`)?.classList?.remove(`stepper__procced`);
    }    
  }
  
  document.querySelectorAll('[js-collapsible-header]').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      if( target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && window.screen.width < 750 && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
        collapsibleTab(target);
      }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
        collapsibleTabOpenTime(target);
      }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
        collapsibleTab(target);
      }
    })
  });

  document.querySelectorAll('[js-mega-menu]').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let megaMenuId = target.currentTarget.dataset.megaMenu;
      let sectionId = target.target.closest('.header__fully__customizable').dataset.sectionId;
      target.target.closest('.main__header__wrapper').classList.add('active-dropdown');
      document.querySelectorAll(`.header__megamenu__wrapper`).forEach((elm)=>{ elm.classList.remove('active'); });
      document.querySelector(`.header__megamenu__wrapper[data-mega-menu-opener="${megaMenuId}"]`).classList.add('active');
      document.querySelector(`#shopify-section-${sectionId}`).classList.add('active');
      document.querySelector(`.js-dropdown-close`).classList.add('active');
      document.body.classList.add('overflow-hidden','desktop__header_visible');
      document.querySelector('.page-blury-overlay').classList.add('is-visible');
    })
  });

  document.querySelector('.js-dropdown-close').addEventListener('click', (target)=>{
    target.preventDefault();
    let sectionId = document.querySelector('.header__fully__customizable').dataset.sectionId;
    document.querySelector('.main__header__wrapper').classList.remove('active-dropdown','active', 'menu-open');
    target.target.closest('.main__header__interior').classList.remove('menu-open');
    document.querySelectorAll(`.header__megamenu__wrapper`).forEach((elm)=>{ elm.classList.remove('active'); });
    document.querySelector(`[data-mega-menu-mobile-opener="mobile-mega-menu"]`).classList.remove('active');
    document.querySelector(`#shopify-section-${sectionId}`).classList.remove('active');
    document.querySelector(`.js-dropdown-close`).classList.remove('active');
    document.body.classList.remove('overflow-hidden','mobile__header_visible','desktop__header_visible');   
    document.querySelector('.page-blury-overlay').classList.remove('is-visible','is-visible-mobile');
  });

  document.querySelector('.js-mobile-dropdown-close').addEventListener('click', (target)=>{
    target.preventDefault();
    let sectionId = document.querySelector('.header__fully__customizable').dataset.sectionId;
    document.querySelector('.main__header__wrapper').classList.remove('active-dropdown','active', 'menu-open');
    document.querySelector('.main__header__interior').classList.remove('menu-open');
    document.querySelectorAll(`.header__megamenu__wrapper`).forEach((elm)=>{ elm.classList.remove('active'); });
    document.querySelector(`[data-mega-menu-mobile-opener="mobile-mega-menu"]`).classList.remove('active');
    document.querySelector(`#shopify-section-${sectionId}`).classList.remove('active');
    document.querySelector(`.js-dropdown-close`).classList.remove('active');
    document.body.classList.remove('overflow-hidden','mobile__header_visible','desktop__header_visible');   
    document.querySelector('.page-blury-overlay').classList.remove('is-visible','is-visible-mobile');
  });  

  document.querySelector('.page-blury-overlay').addEventListener('click', ()=>{ overlayRemoved() });
  document.querySelector('.page-overlay').addEventListener('click', ()=>{ overlayRemoved() });

  document.querySelectorAll('[js-mobile-menu]').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      let sectionId = target.target.closest('.header__fully__customizable').dataset.sectionId;
      target.target.closest('.main__header__wrapper').classList.add('active', 'menu-open');
      target.target.closest('.main__header__interior').classList.add('menu-open');
      document.querySelector(`[data-mega-menu-mobile-opener="mobile-mega-menu"]`).classList.add('active');
      document.querySelector(`#shopify-section-${sectionId}`).classList.add('active');
      document.body.classList.add('overflow-hidden', 'mobile__header_visible');
    })
  });

  if( document.querySelectorAll('[href="#healthcare-practitioners"]').length > 0 ){
    document.querySelectorAll('[href="#healthcare-practitioners"]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.querySelector('.healthcare_practitioners__back').classList.add('hidden');
        document.querySelector('.healthcare_fsflow__content').classList.remove('hidden');
        document.querySelector('.healthcare_scflow__content').classList.add('hidden');        
        document.querySelector('.healthcare_practitioners__mainwrapper').classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      })
    }); 
  } 

  class healthcarePractitioners extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[js-cross-healthcare-practitioners]').addEventListener('click', this.crossHealthcarePractitioners.bind(this));
      this.querySelector('[js-back-healthcare-practitioners]').addEventListener('click', this.backHealthcarePractitioners.bind(this));
      this.querySelectorAll('[js-selection-check]').forEach((el)=>{ el.addEventListener('change', this.selectionHealthcarePractitioners.bind(this)) });
      this.querySelector('[js-fflow-healthcare-practitioners]').addEventListener('click', this.fflowHealthcarePractitioners.bind(this));
      this.querySelectorAll(`[js-validation-check]`).forEach((el)=>{el.addEventListener('change', this.debugHealthcarePractitioners.bind(this)) });
      this.querySelector('[js-sflow-healthcare-practitioners]').addEventListener('click', this.sflowHealthcarePractitioners.bind(this));
    }
    backHealthcarePractitioners(){
      this.querySelector('.healthcare_practitioners__back').classList.add('hidden');
      this.querySelector('.healthcare_fsflow__content').classList.remove('hidden');
      this.querySelector('.healthcare_scflow__content').classList.add('hidden');
    }
    crossHealthcarePractitioners(){
      this.querySelector('.healthcare_practitioners__mainwrapper').classList.remove('active');
      document.querySelector('.page-overlay').classList.remove('is-visible');
      document.body.classList.remove('overflow-hidden');
    }
    selectionHealthcarePractitioners(target){
      this.querySelectorAll('[js-selection-check]').forEach((el)=>{el.closest('.healthcare_fsflow__optionxt').classList.remove('active')});
      this.querySelector('.healthcare_fsflow__content_options').classList.remove('error');
      target.target.closest('.healthcare_fsflow__optionxt').classList.add('active');
    }
    fflowHealthcarePractitioners(){
      if(this.querySelector('input[name="healthcarePractitioner"]:checked')){
        if( this.querySelector('input[name="healthcarePractitioner"]:checked').value == 'No' ){
          this.querySelector('.healthcare_practitioners__mainwrapper').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');          
          window.location.reload(true);
        }else{
          this.querySelector('.healthcare_practitioners__back').classList.remove('hidden');
          this.querySelector('.healthcare_fsflow__content').classList.add('hidden');
          this.querySelector('.healthcare_scflow__content').classList.remove('hidden');
          this.querySelector('.healthcare_fsflow__content_options').classList.remove('error');
        }
      }else{
        this.querySelector('.healthcare_fsflow__content_options').classList.add('error');
      }
    }
    debugHealthcarePractitioners(target){
      this.stringRegex = /^[A-Za-z\s]*$/;
      this.stringRegexSC = /^[A-Za-z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
      if( target.target.getAttribute('name') == 'healthcarePractitionerFirstName' ){
        this.firstName = target.target.value;
        this.firstName = this.firstName.trim();
        if( !this.stringRegex.test(this.firstName) ){
          target.target.classList.add('notvalid');
        }else{
          target.target.classList.remove('notvalid','empty_error');
        }
      }else if( target.target.getAttribute('name') == 'healthcarePractitionerLastName' ){
        this.lastName = target.target.value;
        this.lastName = this.lastName.trim();
        if( !this.stringRegex.test(this.lastName) ){
          target.target.classList.add('notvalid');
        }else{
          target.target.classList.remove('notvalid','empty_error');
        }        
      }else if( target.target.getAttribute('name') == 'healthcarePractitionerPracticeName' ){
        this.practiceName = target.target.value;
        this.practiceName = this.practiceName.trim();
        if( !this.stringRegexSC.test(this.practiceName) ){
          target.target.classList.add('notvalid');
        }else{
          target.target.classList.remove('notvalid','empty_error');
        }        
      }else if( target.target.getAttribute('name') == 'healthcarePractitionerEmail' ){
        this.Email = target.target.value;
        this.Email = this.Email.trim();
        this.Email = this.Email.toLowerCase();
        this.email$CodeRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if ( this.Email.length === 0  ){
          target.target.classList.remove('notvalid','empty_error');
        }else if ( !this.Email.includes('.com') &&
          !this.Email.includes('.org') &&
          !this.Email.includes('.edu') &&
          !this.Email.includes('.gov') &&
          !this.Email.includes('.net') &&
          !this.Email.includes('.int') &&
          !this.Email.includes('.mil') &&
          !this.Email.includes('.arpa') &&
          !this.Email.includes('.amex') &&
          !this.Email.includes('.art') &&
          !this.Email.includes('.co')
        ) {
          target.target.classList.add('notvalid');
        }else if (!this.email$CodeRegex.test(this.Email)) {
          target.target.classList.add('notvalid');
        }else{
          target.target.classList.remove('notvalid','empty_error');
        }  
      }
    }
    async sflowHealthcarePractitioners(target){
      this.AllCorrections = [];
      target.target.closest('.healthcare_scflow__content').querySelectorAll('input').forEach((el)=>{
        this.emptyCheck = el.value.trim();
        if(el.value == ''){
          el.classList.add('empty_error');
        }else if( el.classList.contains('notvalid') ){
          el.classList.add('empty_error');
        }else{
          this.AllCorrections.push('true')
        }
      })

      if( this.AllCorrections.length == 4 ){
        this.targetEl = target.target;
        this.targetEl.style.pointerEvents = 'none';
        this.AcceptPractice = target.target.closest('.healthcare_practitioners__content').querySelector('input[name="healthcarePractitioner"]:checked')?.value?.trim() || '';
        this.AcceptFirstName = target.target.closest('.healthcare_scflow__content').querySelector('input[name="healthcarePractitionerFirstName"]')?.value?.trim() || '';
        this.AcceptLastName = target.target.closest('.healthcare_scflow__content').querySelector('input[name="healthcarePractitionerLastName"]')?.value?.trim() || '';
        this.AcceptEmail = target.target.closest('.healthcare_scflow__content').querySelector('input[name="healthcarePractitionerEmail"]')?.value?.trim() || ''; 
        this.AcceptPracticeName = target.target.closest('.healthcare_scflow__content').querySelector('input[name="healthcarePractitionerPracticeName"]')?.value?.trim() || ''; 

        this.payload = {
            data: {
                type: 'subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                properties: {
                                    'SMS Consent': 'FALSE',
                                    'healthcare_practitioner': this.AcceptPractice,
                                    'practice_name': this.AcceptPracticeName
                                },
                                email: this.AcceptEmail,
                                first_name: this.AcceptFirstName,
                                last_name: this.AcceptLastName
                            }
                        }
                    }
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: 'SigRRd'
                        }
                    }
                }
            }
        };
        try {
          this.response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UFRh4Z', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'REVISION': '2024-07-15'
            },
            body: JSON.stringify(this.payload)
          });
          if (!this.response.ok) {
            throw new Error(`Request failed. Status: ${this.response.status}`);
          }
          this.responseText = await this.response.text();
          this.querySelector('.healthcare_practitioners__mainwrapper').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');
          this.targetEl.style.pointerEvents = 'auto';
          window.location.href = "/pages/hcp-portal";
          if (this.responseText) { 
            try {
              const json = JSON.parse(this.responseText);
            } catch (err) {
              console.error('Invalid JSON response:', err);
            }
          } else {
            console.log('Response was empty');
          }
        } catch (error) {
          console.error('Submission error:', error);
        }

      }
    }
  }
  customElements.define('popup-healthcare-practitioners', healthcarePractitioners);  

  if (!customElements.get('drawer-open')) {
  class DrawerOpen extends HTMLElement {
    constructor() {
      super();
      this.drawerHtml = this.drawerHtml.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.drawerHtml);
    }    
    drawerHtml() {
      const handleEl = this.querySelector('[data-handle]');
      lastClickedLearnMore = this;
      if( document.querySelectorAll('[data-section-type="page-collection-curated-otp-grid"]').length > 0 ){
        this.querySelector('.open__drawerLink').classList.add('active');
      }
      if (!handleEl) return;
      if( handleEl.dataset.handle.includes('#chronic-popup') ){
        document.querySelector('.chronic-illness-slide-out')?.classList.add('active');
        document.body.classList.add('overflow-hidden'); 
      }else{
        const acceptedHandle = handleEl.dataset.handle;
        const targetContainer = document.querySelector('[js-lightbox-custom-drawer]');
        if (!acceptedHandle || !targetContainer) return;
        fetch(`/pages/${acceptedHandle}`)
          .then(response => response.text())
          .then(htmlString => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const sectionEl = doc.querySelector('.custom__drawers__layout');
            if (!sectionEl || !sectionEl.dataset.sectionId) return;
            const sectionId = sectionEl.dataset.sectionId;
            const contentHtml = doc.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section')?.innerHTML;
            if (!contentHtml) return;
            targetContainer.innerHTML = contentHtml;
            this.initDrawerScripts(targetContainer);
          })
          .catch(err => {
            console.error("Drawer fetch error:", err);
          });
      }
    }
    initDrawerScripts(container) {
      container.closest('.custom__drawer__management').classList.add('active');
      document.querySelector('.page-overlay').classList.add('is-visible');
      document.body.classList.add('overflow-hidden');
      const closeBtn = container.querySelectorAll('[js-shutdown-drawer]');
      if (closeBtn.length > 0) {
        closeBtn.forEach((elm)=>{
          elm.addEventListener('click', () => {
            container.closest('.custom__drawer__management').classList.remove('active');
            container.innerHTML = '';
            document.querySelector('.page-overlay').classList.remove('is-visible');
            document.body.classList.remove('overflow-hidden');
            document.querySelectorAll('.open__drawerLink').forEach((el)=>{el.classList.remove('active') });
          });
        })
      }
      container.dispatchEvent(new CustomEvent('customDrawer:loaded', { bubbles: true }));
    }
  }
  customElements.define('drawer-open', DrawerOpen);
  }

  if (!customElements.get('drawer-open-md')) {
  class DrawerOpenSub extends HTMLElement {
    constructor() {
      super();
      this.drawerHtml = this.drawerHtml.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.drawerHtml);
    }    
    drawerHtml() {
      const handleEl = this.querySelector('[data-handle]');
      if (!handleEl) return;
      const acceptedHandle = handleEl.dataset.handle;
      const targetContainer = document.querySelector('[js-sub-lightbox-custom-drawer]');
      if (!acceptedHandle || !targetContainer) return;
      fetch(`/pages/${acceptedHandle}`)
        .then(response => response.text())
        .then(htmlString => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const sectionEl = doc.querySelector('.custom__drawers__layout');
          if (!sectionEl || !sectionEl.dataset.sectionId) return;
          const sectionId = sectionEl.dataset.sectionId;
          const contentHtml = doc.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section')?.innerHTML;
          if (!contentHtml) return;
          targetContainer.innerHTML = contentHtml;
          targetContainer.querySelector('.cross__product_drawer').innerHTML = `<span class="closed__wp_mp">Back</span><span class="icon__wp_mp"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"> <path d="M3.05585 9.17006L9.44904 15.5564L8.5 16.5L0.5 8.5L8.5 0.5L9.44904 1.44358L3.05585 7.82994H16.5V9.17006H3.05585Z" fill="#1F2322"></path> </svg></span>`
          this.initDrawerScripts(targetContainer);
        })
        .catch(err => {
          console.error("Drawer fetch error:", err);
        });
    }
    initDrawerScripts(container) {
      container.closest('.custom__drawer__management').classList.add('active');
      const closeBtn = container.querySelectorAll('[js-shutdown-drawer]');
      if (closeBtn.length > 0) {
        closeBtn.forEach((elm)=>{
          elm.addEventListener('click', () => {
            container.closest('.custom__drawer__management').classList.remove('active');
            container.innerHTML = '';
          });
        });          
      }
      container.dispatchEvent(new CustomEvent('customDrawer:loaded', { bubbles: true }));
    }
  }
  customElements.define('drawer-open-md', DrawerOpenSub); 
  } 

  document.addEventListener('customDrawer:loaded', function (event) {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const LearnMoremediaEl = document.querySelectorAll('.Lmore_media__exceution_swiper.swiper');
    if(LearnMoremediaEl.length > 0) {
      const LearnMoremediaConfig = {spaceBetween:0,mousewheel: {forceToAxis: true,thresholdDelta: 35},allowTouchMove: true,slidesPerView:'auto',pagination:{el:'.swiper-pagination',type:'progressbar'} };
      LearnMoremediaEl.forEach((ltel)=>{
      new Swiper(ltel, LearnMoremediaConfig);
      })
    }
    const LearnMoretestimonialEl = document.querySelectorAll('.Lmore__Testimonial__reviews_interior.swiper');
    if(LearnMoretestimonialEl.length > 0) {
      const LearnMoretestimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true,mousewheel: {forceToAxis: true,thresholdDelta: 35},allowTouchMove: true };
      if (!isIOS) {
        LearnMoretestimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        LearnMoretestimonialConfig.freeMode = true;
      }
      LearnMoretestimonialEl.forEach((ltel)=>{
      new Swiper(ltel, LearnMoretestimonialConfig);
      })
    }   
    const LearnMoreswiperElements = document.querySelectorAll('.Lmore__accordion_collapsible .iconText_highPricePoint_swipe.swiper');
    if(LearnMoreswiperElements.length > 0) {
      LearnMoreswiperElements.forEach((elm, index) => {
        const configL = { spaceBetween: 12, slidesPerView: 'auto', allowTouchMove: true, grabCursor: true, };
        if (!isIOS) { configL.mousewheel = { forceToAxis: true, thresholdDelta: 35 }; configL.freeMode = true; }
        new Swiper(elm, configL);
      });
    }   
    const clinicalProcessswiperElements = document.querySelectorAll('.clinicalProcess_MainsSwiper.swiper');
    if(clinicalProcessswiperElements.length > 0) {
      clinicalProcessswiperElements.forEach((elm, index) => {
        const config = {
          spaceBetween: 12,
          slidesPerView: 'auto',
          allowTouchMove: true,
          grabCursor: true,
          keyboard: { enabled: true }
        };
        if (!isIOS) {
          config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
          config.freeMode = true;
        }
        const clinicalProcesscvswiperElements = new Swiper(elm, config);
      });
    } 
    const clinicalChartswiperElements = document.querySelectorAll("[data-swiper='chart-images']")
    if(clinicalChartswiperElements.length > 0){ 
      clinicalChartswiperElements.forEach(s => {
        const options = {
          slidesPerView: 1.2,spaceBetween: 8,
          pagination: {el: '.swiper-pagination',clickable: true},
        }
        if(s.nextElementSibling.hasAttribute('data-swiper')) {
          const textSwiper = new Swiper( s.nextElementSibling, {
            slidesPerView: 1,effect: 'fade'})
          options.controller = {by: 'slide',control: textSwiper}
          const clinicalChartMnswiperElements = new Swiper(s, options) 
        }
      })
    }
    const fav__noidsswiperElements = document.querySelectorAll('.favonoids__main_layout .fav__noids_wrapper.swiper');
    if(fav__noidsswiperElements.length > 0) {
      fav__noidsswiperElements.forEach((elm, index) => {
        const config = {
          spaceBetween: 12,
          slidesPerView: 'auto',
          allowTouchMove: true,
          grabCursor: true,
          keyboard: { enabled: true }
        };
        if (!isIOS) {
          config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
          config.freeMode = true;
        }
        const fav__noidscvswiperElements = new Swiper(elm, config);
      });
    }

    const howtousemediaEl = document.querySelectorAll('.hw__use__media_ct_sc__items__swp.swiper');
    if(howtousemediaEl.length > 0) {
      const howtousemediaConfig = {spaceBetween:12,mousewheel: {forceToAxis: true,thresholdDelta: 35},allowTouchMove: true,slidesPerView:'auto',navigation: { nextEl: `.hw__use__media_ct__sc__header__nav .swiper-button-next`, prevEl: `.hw__use__media_ct__sc__header__nav .swiper-button-prev` }};
      howtousemediaEl.forEach((ltel)=>{
      new Swiper(ltel, howtousemediaConfig);
      })
    }


    if( document.querySelectorAll('.custom__drawer__management [js-collapsible-header]').length > 0 && document.querySelector('.sub__drawer__layout_main').querySelector('[js-sub-lightbox-custom-drawer]').childElementCount == 0 ){
      document.querySelectorAll('.custom__drawer__management [js-collapsible-header]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          if( target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && window.screen.width < 750 && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
          }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTabOpenTime(target);
          }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
          }
        })
      }); 
    }
    if( document.querySelectorAll('.sub__drawer__layout_main [js-collapsible-header]').length > 0 && document.querySelector('.sub__drawer__layout_main').querySelector('[js-sub-lightbox-custom-drawer]').childElementCount != 0 ){
      document.querySelectorAll('.sub__drawer__layout_main [js-collapsible-header]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          if( target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && window.screen.width < 750 && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
          }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTabOpenTime(target);
          }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
          }
        })
      }); 
    }    
    if( document.querySelectorAll('.Lmore_icon_morecontext span').length ){
      document.querySelectorAll('.Lmore_icon_morecontext span').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.target.closest('.Lmore_icon_morecontext').classList.add('hidden');
          target.target.closest('.Lmore__icons_text_wrapper').querySelectorAll('.xt_v_fv_iconTxt').forEach((td)=>{ td.classList.remove('hidden') });
        })
      })
    }
    if( document.querySelectorAll('.wildFdUsVsThemtblMnWp').length > 0 ){
      document.querySelectorAll('.WildUsThmBTn').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          if( target.currentTarget.classList.contains('WildUsThmBTnRed') ){
            target.currentTarget.classList.add('active');
            target.target.closest('.wildFdUsThmtblTbBtn').querySelector('.WildUsThmBTn.WildUsThmBTnThm').classList.remove('active');
            target.target.closest('.wildFdUsVsThemtblMnWp').querySelector('.wildFdUsVsThemtblOtWp').querySelector('.wildFdUsVsThemtblBothBx.wildFdUsVsThemtblReds').classList.add('active');
            target.target.closest('.wildFdUsVsThemtblMnWp').querySelector('.wildFdUsVsThemtblOtWp').querySelector('.wildFdUsVsThemtblBothBx.wildFdUsVsThemtblthem').classList.remove('active');
          }else if( target.currentTarget.classList.contains('WildUsThmBTnThm') ){
            target.currentTarget.classList.add('active');
            target.target.closest('.wildFdUsThmtblTbBtn').querySelector('.WildUsThmBTn.WildUsThmBTnRed').classList.remove('active');  
            target.target.closest('.wildFdUsVsThemtblMnWp').querySelector('.wildFdUsVsThemtblOtWp').querySelector('.wildFdUsVsThemtblBothBx.wildFdUsVsThemtblthem').classList.add('active');
            target.target.closest('.wildFdUsVsThemtblMnWp').querySelector('.wildFdUsVsThemtblOtWp').querySelector('.wildFdUsVsThemtblBothBx.wildFdUsVsThemtblReds').classList.remove('active');
          }
        })
      })
      const scrollBox = document.querySelector('.wildFdUsVsThemtblOtWp');
      let isDragging = false;
      let dragStartX;
      let initialScrollX;
      scrollBox.addEventListener('mousedown', (event) => {
        isDragging = true;
        scrollBox.classList.add('is-dragging');
        dragStartX = event.pageX - scrollBox.offsetLeft;
        initialScrollX = scrollBox.scrollLeft;
      });
      scrollBox.addEventListener('mouseleave', () => {
        isDragging = false;
        scrollBox.classList.remove('is-dragging');
      });
      scrollBox.addEventListener('mouseup', () => {
        isDragging = false;
        scrollBox.classList.remove('is-dragging');
      });
      scrollBox.addEventListener('mousemove', (event) => {
        if (!isDragging) return;
        event.preventDefault();
        const currentX = event.pageX - scrollBox.offsetLeft;
        const distanceMoved = (currentX - dragStartX) * 1.5;
        scrollBox.scrollLeft = initialScrollX - distanceMoved;
      });             
    }
    if( document.querySelectorAll('.bouywildFdTblOut').length > 0 ){
      const scrollFoodChart = document.querySelector('.bouywildFdTblOut');
      let isDown = false;
      let startX;
      let scrollLeft;
      scrollFoodChart.addEventListener('mousedown', (e) => {
        isDown = true;
        scrollFoodChart.classList.add('dragging');
        startX = e.pageX - scrollFoodChart.offsetLeft;
        scrollLeft = scrollFoodChart.scrollLeft;
      });
      scrollFoodChart.addEventListener('mouseleave', () => {
        isDown = false;
        scrollFoodChart.classList.remove('dragging');
      });
      scrollFoodChart.addEventListener('mouseup', () => {
        isDown = false;
        scrollFoodChart.classList.remove('dragging');
      });
      scrollFoodChart.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollFoodChart.offsetLeft;
        const walk = (x - startX) * 1.5;
        scrollFoodChart.scrollLeft = scrollLeft - walk;
      }); 
    }
    
    if(document.querySelectorAll('.worth_stickyDragged_Interior').length > 0) {
      const drawers = [
        {
          handle: '[data-section-type="why-wild-foods-drawer"]',
        },
        {
          handle: '[data-section-type="phytonutrients-drawer"]',
        }        
      ];
      const supportsSmooth = 'scrollBehavior' in document.documentElement.style;
      function easeInOut(progress) {
        return progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;
      }
      function smoothScroll(container, target, duration = 300, axis = 'Y') {
        const start = axis === 'Y' ? container.scrollTop : container.scrollLeft;
        const change = target - start;
        if (Math.abs(change) < 1) return;
        let startTime = null;
        function animate(currentTime) {
          if (!startTime) startTime = currentTime;
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = easeInOut(progress);
          if (axis === 'Y') container.scrollTop = start + change * eased;
          else container.scrollLeft = start + change * eased;
          if (progress < 1) requestAnimationFrame(animate);
        }
        requestAnimationFrame(animate);
      }
      drawers.forEach(({ handle }) => {
        const drawer = document.querySelector(handle);
        if(drawer){
          const tabs = drawer.querySelectorAll('.drawer-tab[data-tab]');
          const content = drawer.querySelector('.Phythonutrients__mainContent');
          const header = drawer.querySelector('.custom__drawer_header');
          const tabsWrapper = drawer.querySelector('.worth_stickyDragged_Interior');
          const sections = drawer.querySelectorAll('.tab-contentpy[id]');
          if (!tabs.length || !content || !tabsWrapper || !sections.length) return;
          const offsetTop = (header?.clientHeight || 0) + tabsWrapper.clientHeight;
          let autoScrolling = false;
          let scrollTimeout = null;
          let currentActiveIndex = -1;
          function activateTab(index) {
            if (index === currentActiveIndex || index === -1) return;
            currentActiveIndex = index;
            tabs.forEach(tab => tab.classList.remove('active'));
            tabs[index].classList.add('active');
            ensureTabVisible(index);
          }
          function ensureTabVisible(index) {
            const current = tabs[index];
            if (!current) return;
            const containerWidth = tabsWrapper.offsetWidth;
            const padding = 20;
            const scrollTarget = (tabs[index - 1]?.offsetLeft ?? current.offsetLeft) - padding;
            const maxScroll = tabsWrapper.scrollWidth - containerWidth;
            const clamped = Math.min(Math.max(0, scrollTarget), maxScroll);
            smoothScroll(tabsWrapper, clamped, 300, 'X');
          }
          tabs.forEach((tab, index) => {
            tab.addEventListener('click', (e) => {
              e.preventDefault();
              const tabId = tab.dataset.tab;
              const section = drawer.querySelector(`.tab-contentpy[id="${tabId}"]`);
              if (!section) return;
              const containerRect = content.getBoundingClientRect();
              const sectionRect = section.getBoundingClientRect();
              const scrollTop = content.scrollTop + (sectionRect.top - containerRect.top) - offsetTop;
              autoScrolling = true;
              if (supportsSmooth) {
                content.scrollTo({ top: scrollTop, behavior: 'smooth' });
              } else {
                smoothScroll(content, scrollTop);
              }
              activateTab(index);
            });
          });
          content.addEventListener('scroll', () => {
            if (autoScrolling) {
              clearTimeout(scrollTimeout);
              scrollTimeout = setTimeout(() => {
                autoScrolling = false;
              }, 150);
              return;
            }
            const contentRect = content.getBoundingClientRect();
            let visibleIndex = -1;
            sections.forEach((section, i) => {
              const rect = section.getBoundingClientRect();
              const topInView = rect.top >= contentRect.top + offsetTop;
              const bottomInView = rect.bottom <= contentRect.bottom;
              const partiallyVisible = rect.top < contentRect.bottom && rect.bottom > contentRect.top + offsetTop;
              if (partiallyVisible && visibleIndex === -1) {
                visibleIndex = i;
              }
            });
            if (visibleIndex !== -1) {
              activateTab(visibleIndex);
            }
          });
        }
      });
    }
    if( document.querySelectorAll('.ly__media_playpauseIcon').length > 0 ){
        document.querySelectorAll('.ly_playPause_func').forEach((elm)=>{
          elm.addEventListener('click', (target)=>{
          target.preventDefault();
          let targetVideo = target.target.closest('.Lyophilized__main_md').querySelector('video');
          if (targetVideo && !targetVideo.paused) {
            targetVideo.pause();
            target.target.closest('.ly__media_playpauseIcon').querySelector('.ly_playPause_func').innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M16.4275 10.3655C17.7826 11.2682 17.7819 12.7323 16.4275 13.6345L9.00844 18.5764C7.65327 19.4791 6.55469 18.8914 6.55469 17.2656V6.73441C6.55469 5.10772 7.654 4.52131 9.00844 5.42352L16.4275 10.3655Z" fill="white"/> </svg>`;
          }else if(targetVideo && targetVideo.paused){
            targetVideo.play();
            target.target.closest('.ly__media_playpauseIcon').querySelector('.ly_playPause_func').innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M14 19V5H18V19H14ZM6 19V5H10V19H6Z" fill="white"></path> </svg>`;
          }                
        })
      })
      document.querySelectorAll('.ly_sound_func').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          let targetVideo = target.target.closest('.Lyophilized__main_md').querySelector('video');
          if (targetVideo && !targetVideo.muted) {
            targetVideo.muted = true;
            target.target.closest('.ly__media_playpauseIcon').querySelector('.ly_sound_func').innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M21.9102 9.41406L16.3027 15.022" stroke="white" stroke-width="1.05359" stroke-linecap="round"></path> <path d="M12.2151 18.2321V6.12467C12.2151 5.67804 11.6942 5.43405 11.3511 5.71996L7.33518 9.0663C7.24051 9.14518 7.12118 9.18838 6.99795 9.18838H3.52679C3.23585 9.18838 3 9.42424 3 9.71518V14.526C3 14.8169 3.23585 15.0528 3.52679 15.0528H6.99312C7.11928 15.0528 7.24125 15.0981 7.33685 15.1804L11.3446 18.6313C11.6861 18.9253 12.2151 18.6827 12.2151 18.2321Z" fill="white"></path> <path d="M16.3008 9.41406L21.9083 15.022" stroke="white" stroke-width="1.05359" stroke-linecap="round"></path> </svg>`;
          }else if(targetVideo && targetVideo.muted){
            targetVideo.muted = false;
            target.target.closest('.ly__media_playpauseIcon').querySelector('.ly_sound_func').innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M5.34763 8.67936H8.2029L12.1532 4.75977L13.0231 5.11795V18.422L12.1532 18.7598L8.2029 14.8197H5.34763L4.83594 14.308V9.19105L5.34763 8.67936ZM8.776 13.9703L11.9997 17.1837V6.35626L8.776 9.54924L8.41781 9.70275H5.85933V13.7963H8.41781L8.776 13.9703ZM19.1634 11.7495C19.1661 13.4015 18.5953 15.0032 17.5485 16.2811L16.8199 15.5545C17.677 14.4717 18.1423 13.1305 18.14 11.7495C18.14 10.3168 17.6488 8.99763 16.826 7.95275L17.5547 7.22614C18.5974 8.5028 19.1659 10.1012 19.1634 11.7495ZM17.1166 11.7495C17.1186 12.8586 16.7585 13.938 16.0912 14.8238L15.3585 14.0911C15.8382 13.4046 16.0947 12.587 16.0932 11.7495C16.0932 10.8827 15.8241 10.0783 15.3636 9.4162L16.0963 8.68345C16.737 9.53798 17.1166 10.5992 17.1166 11.7495ZM15.0699 11.7495C15.0699 12.337 14.9061 12.8855 14.6196 13.3522L13.8633 12.5969C13.9842 12.3325 14.0472 12.0454 14.0481 11.7547C14.049 11.464 13.9877 11.1765 13.8684 10.9114L14.6247 10.1551C14.9071 10.6197 15.0699 11.1662 15.0699 11.7495Z" fill="white"/> </svg>`;
          }             
        })
      })
    }    
    if( document.querySelectorAll('.drawer-tabs').length > 0 ) {
      const drawersTh = [
        {
          handle: '[data-section-type="third-party-drawer"]',
        }
      ];
      const supportsSmooth = 'scrollBehavior' in document.documentElement.style;
      function easeInOut(progress) {
        return progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;
      }
      function smoothScroll(container, target, duration = 300, axis = 'Y') {
        const start = axis === 'Y' ? container.scrollTop : container.scrollLeft;
        const change = target - start;
        if (Math.abs(change) < 1) return;
        let startTime = null;
        function animate(currentTime) {
          if (!startTime) startTime = currentTime;
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = easeInOut(progress);
          if (axis === 'Y') container.scrollTop = start + change * eased;
          else container.scrollLeft = start + change * eased;
          if (progress < 1) requestAnimationFrame(animate);
        }
        requestAnimationFrame(animate);
      }
      drawersTh.forEach(({ handle }) => {
        const drawer = document.querySelector(handle);
        const tabs = drawer.querySelectorAll('.drawer-tab[data-tab]');
        const content = drawer.querySelector('.drawer__content__box');
        const header = drawer.querySelector('.custom__drawer_header');
        const tabsWrapper = drawer.querySelector('.drawer-tabs');
        const sections = drawer.querySelectorAll('.tab-content[id]');
        if (!tabs.length || !content || !tabsWrapper || !sections.length) return;
        const offsetTop = (header?.clientHeight || 0);
        let autoScrolling = false;
        let scrollTimeout = null;
        let currentActiveIndex = -1;
        function activateTab(index) {
          if (index === currentActiveIndex || index === -1) return;
          currentActiveIndex = index;
          tabs.forEach(tab => tab.classList.remove('active'));
          tabs[index].classList.add('active');
          ensureTabVisible(index);
        }
        function ensureTabVisible(index) {
          const current = tabs[index];
          if (!current) return;
          const containerWidth = tabsWrapper.offsetWidth;
          const padding = 16;
          const scrollTarget = (tabs[index - 1]?.offsetLeft ?? current.offsetLeft) - padding;
          const maxScroll = tabsWrapper.scrollWidth - containerWidth;
          const clamped = Math.min(Math.max(0, scrollTarget), maxScroll);
          smoothScroll(tabsWrapper, clamped, 300, 'X');
        }
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', (e) => {
            e.preventDefault();
            const tabId = tab.dataset.tab;
            const section = drawer.querySelector(`.tab-content[id="${tabId}"]`);
            if (!section) return;
            const containerRect = content.getBoundingClientRect();
            const sectionRect = section.getBoundingClientRect();
            const scrollTop = content.scrollTop + (sectionRect.top - containerRect.top) - offsetTop;
            autoScrolling = true;
            if (supportsSmooth) {
              content.scrollTo({ top: scrollTop, behavior: 'smooth' });
            } else {
              smoothScroll(content, scrollTop);
            }
            activateTab(index);
          });
        });
        content.addEventListener('scroll', () => {
          if (autoScrolling) {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              autoScrolling = false;
            }, 150);
            return;
          }
          const contentRect = content.getBoundingClientRect();
          let visibleIndex = -1;
          sections.forEach((section, i) => {
            const rect = section.getBoundingClientRect();
            const topInView = rect.top >= contentRect.top + offsetTop;
            const bottomInView = rect.bottom <= contentRect.bottom;
            const partiallyVisible = rect.top < contentRect.bottom && rect.bottom > contentRect.top + offsetTop;
            if (partiallyVisible && visibleIndex === -1) {
              visibleIndex = i;
            }
          });
          if (visibleIndex !== -1) {
            activateTab(visibleIndex);
          }
        });
      });
    }
    if( document.querySelectorAll('.Inteior_tab__layoutph .see_more_visibleBtn').length > 0 ){
        document.querySelectorAll('.MoreSee_visivle_Btn').forEach((elm)=>{
          elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.target.closest('.tab-contents-containerph').classList.add('viewAll');
          target.target.closest('.Inteior_tab__layoutph').querySelectorAll('.wp__Rds_main_Outeryt').forEach((elm)=>{
            elm.classList.remove('hidden');
          })
        })
      })
    }
    if( document.querySelectorAll('.Lmore__video__playIcon').length > 0 ){
      document.querySelectorAll('.Lmore__video__playIcon .Lmore__action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Lmore__Testimonial__video_tagged').querySelector('.Lmore__action--play').classList.remove('hidden');
          target.target.closest('.Lmore__Testimonial__video_tagged').querySelector('video').pause();
        }) 
      });
      document.querySelectorAll('.Lmore__video__playIcon .Lmore__action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Lmore__Testimonial__video_tagged').querySelector('.Lmore__action--pause').classList.remove('hidden');
          target.target.closest('.Lmore__Testimonial__video_tagged').querySelector('video').play();
        })
      });  
    } 

    if (!window.customDrawerInitialized) {
      document.addEventListener('click', function (event) {
        const spanClick = event.target.closest('[data-learn-purchase] span');
        if (!spanClick) return;
        event.preventDefault();
        event.stopPropagation();
        const parentEl = event.target.closest('[data-learn-purchase]');
        if (parentEl.classList.contains('is-processing')) return;
        parentEl.classList.add('is-processing');
        document.querySelector('.page-overlay')?.classList.remove('is-visible');
        document.querySelectorAll('.custom__drawer__management').forEach(drawer => {
          drawer.classList.remove('active');
        });
        const mainDrawer = document.querySelector('[js-lightbox-custom-drawer]');
        const subDrawer = document.querySelector('[js-sub-lightbox-custom-drawer]');
        if (mainDrawer) mainDrawer.innerHTML = '';
        if (subDrawer) subDrawer.innerHTML = '';
        document.body.classList.remove('overflow-hidden', 'scrollOff-quickadd');
        let gethandlePurchase = parentEl.dataset.learnPurchase;
        if (gethandlePurchase && document.querySelector(`[handle-learn-purchase="${gethandlePurchase}"]`) && document.querySelectorAll(`.this__bundle___pdp___mn`).length == 0) {
          document.querySelector(`[handle-learn-purchase="${gethandlePurchase}"]`).click();
        } else if (document.querySelectorAll('[js-scroll-identity]').length > 0) {
          document.querySelector(`[js-scroll-identity]`).click();
        } else if (document.querySelectorAll('[data-section-type="page-collection-curated-otp-grid"]').length > 0) {
          document.querySelector('.open__drawerLink.active')?.closest('.curatedProductGrid__interior_item')?.querySelector('[js-initiate-cart]')?.click();
        } else if (typeof lastClickedLearnMore !== 'undefined' && lastClickedLearnMore) {
          if (lastClickedLearnMore.closest(`[js-main-item-outer]`)?.querySelector(`[js-button-confiq-outer]`)?.classList.contains('active')) {
            lastClickedLearnMore.closest(`[js-main-item-outer]`)?.querySelector(`[js-button-confiq-plus]`)?.click();
          } else {
            lastClickedLearnMore.closest(`[js-main-item-outer]`)?.querySelector(`[js-button-confiq-add]`)?.click();
          }
        }
        setTimeout(() => { parentEl.classList.remove('is-processing'); }, 300);
      });
      window.customDrawerInitialized = true;
    }

  });
  document.addEventListener('click', function(e) {
    const cartItem = e.target.closest('.cart-drawer__item');
    if (!cartItem) return;
    const link = e.target.closest('a');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.includes('rescue-drops-retail')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})